// @ts-nocheck
/* eslint-disable */
import Content from './content';

/**
 * @class Horní nadpisová část vizitky
 * @private
 */
export default class Title extends Content {
	_build() {
		this._dom.container.classList.add("content-title");
		this._dom.h1 = Mapy.Util.node("h1");
		this._dom.container.appendChild(this._dom.h1);

		// source coor
		if (this._isCoor) {
			this._setFormatTitle();
		}
		else {
			var likeTitle = function(title) {
				this._dom.h1.appendChild(Mapy.Util.text(title));
			}.bind(this);

			if (this._data.userTitle) {
				likeTitle(this._data.userTitle);
			}
			else if (this._data.likeTitle && this._data.likeTitle != this._data.origTitle) {
				likeTitle(this._data.likeTitle);
			}
			else {
				if(this._data.source == "closure") {
					this._dom.h1.classList.add("closure");
				}
				this._dom.h1.appendChild(Mapy.Util.text(this._data.title));
			}
		}
	}

	_setFormatTitle() {
		var newTitle = this._gps.coordsToFormat(this._data.coords);
		this._dom.container.setAttribute("x-ms-format-detection", "none");

		if (this._data.userTitle) {
			this._dom.h1.appendChild(Mapy.Util.text(this._data.userTitle));
		}
		else {
			this._dom.h1.innerHTML = newTitle;
		}

		Mapy.getComponent("detail").changeTitle(this._data.userTitle ? this._data.userTitle : newTitle);
		Mapy.getComponent("detail").setSEO();
	}
}
